<app-mathia-generic-search-filter
    [definitions]="definitions"
    [initialSelection]="initialSelection"
    [defaultValues]="defaultValues"
    [filterConfig]="filterConfig"
    [facetScope]="facetScope"
    [resultCount]="resultCount"
    (selectionChange)="selectionChange.emit($event)">
</app-mathia-generic-search-filter>

